import { create } from "zustand";

const AUTH_API_BASE =
  import.meta.env.VITE_AUTH_API_URL || "http://localhost:8081";

// Default flags (fallback if API is unavailable)
const DEFAULT_FLAGS: Record<string, boolean> = {
  OPTIMIZER: false,
  VIDEO_CATALOG: false,
};

interface FeatureFlagState {
  flags: Record<string, boolean>;
  loaded: boolean;
  fetchFlags: () => Promise<void>;
  isEnabled: (key: string) => boolean;
}

export const useFeatureFlagStore = create<FeatureFlagState>((set, get) => ({
  flags: { ...DEFAULT_FLAGS },
  loaded: false,

  fetchFlags: async () => {
    try {
      const response = await fetch(`${AUTH_API_BASE}/api/v1/feature-flags`);
      if (response.ok) {
        const data = await response.json();
        set({ flags: { ...DEFAULT_FLAGS, ...data }, loaded: true });
      }
    } catch {
      // Silently fall back to defaults if API is unreachable
      set({ loaded: true });
    }
  },

  isEnabled: (key: string) => {
    return get().flags[key] ?? false;
  },
}));
